import React, { memo, forwardRef } from "react";
const SvgNumberthree = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.22 20.14c.28.387.62.687 1.02.9.4.213.88.32 1.44.32.307 0 .613-.04.92-.12.32-.093.6-.233.84-.42.253-.187.453-.427.6-.72.16-.293.24-.653.24-1.08 0-.453-.107-.833-.32-1.14a2.357 2.357 0 00-.78-.72 3.203 3.203 0 00-1-.36c-.36-.08-.68-.12-.96-.12-.24 0-.44-.033-.6-.1a1.295 1.295 0 01-.36-.28.883.883 0 01-.16-.34 1.43 1.43 0 01-.04-.3c0-.08.013-.173.04-.28a.883.883 0 01.16-.34c.093-.107.213-.193.36-.26.16-.08.36-.12.6-.12.267 0 .553-.027.86-.08.32-.053.613-.153.88-.3.267-.16.487-.373.66-.64.187-.28.28-.64.28-1.08 0-.32-.06-.607-.18-.86a1.814 1.814 0 00-.5-.64c-.2-.173-.44-.307-.72-.4a2.525 2.525 0 00-.84-.14c-.467 0-.867.107-1.2.32-.32.2-.6.487-.84.86a1.266 1.266 0 01-.42.42c-.173.107-.367.16-.58.16-.307 0-.567-.093-.78-.28-.2-.2-.3-.453-.3-.76 0-.293.133-.613.4-.96a4.06 4.06 0 011.62-1.3c.667-.307 1.4-.46 2.2-.46.613 0 1.193.087 1.74.26.56.16 1.047.407 1.46.74.427.32.76.72 1 1.2s.36 1.04.36 1.68c0 .76-.233 1.44-.7 2.04-.453.587-1.067.973-1.84 1.16v.04c.867.173 1.567.567 2.1 1.18.547.6.82 1.34.82 2.22 0 .733-.147 1.373-.44 1.92-.28.547-.66 1-1.14 1.36-.467.36-.993.627-1.58.8-.587.187-1.18.28-1.78.28-.96 0-1.82-.153-2.58-.46a4.307 4.307 0 01-1.82-1.44 1.894 1.894 0 01-.3-.5 1.666 1.666 0 01-.06-.44c0-.32.113-.58.34-.78a1.13 1.13 0 01.8-.32c.187 0 .36.047.52.14.173.08.36.26.56.54z"
      />
    </svg>
  );
});
SvgNumberthree.displayName = "SvgNumberthree";
const MemoForwardRef = memo(SvgNumberthree);
export default MemoForwardRef;
